import { Component, AfterViewInit, ChangeDetectorRef, ElementRef, inject, signal, ViewChild  } from '@angular/core';
import { LayoutComponent } from '../../../../shared/layouts/layout/layout.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BadgeModule } from 'primeng/badge';
import { LoadingService } from '../../../../shared/services/loading.service';
import { AcademyService } from '../../../../shared/services/academy/academy.service';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-academy',
  standalone: true,
  imports: [LayoutComponent, BadgeModule, CommonModule],
  templateUrl: './academy.component.html',
  styleUrl: './academy.component.scss'
})
export class AcademyComponent {
  Courses = signal<any[]>([]);
  currentVideoUrl: SafeResourceUrl | null = null;


  private modal: any;
  private observer: IntersectionObserver | null = null;

  constructor(
    private sanitizer: DomSanitizer,
    private academyService: AcademyService,
    private loading: LoadingService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.getCourses();
  }

  getYouTubeThumbnail(videoId: string): string {
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }

  openVideoModal(videoId: string) {
    this.currentVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${videoId}?autoplay=1`);
    this.modal.show();
  }

  closeVideoModal() {
    this.currentVideoUrl = null;
  }

view(course: any) {
  if (course.file) {
    this.router.navigate(['academy/preview'], {
      queryParams: { video: course.file }
    });
  } else {
    window.open(course.url, '_blank');
  }
}

  getCourses() {
    this.loading.Show();

    this.academyService.getCourses().subscribe((res) => {
      this.Courses.set(res);
      this.loading.Hide();
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
